import type { IconSvgObject } from './types';

const LocationFavourite02Icon: IconSvgObject = [
  ["path", { d: "M12 2.38873C7.30558 2.38873 3.5 6.00659 3.5 10.4694C3.5 15.3299 8.21916 17.758 11.1092 21.1947C11.5669 21.739 12.4531 21.7534 12.9211 21.2179C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00659 16.6944 2.38873 12 2.38873Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.7431 7.17834C13.1465 6.34577 12 7.57306 12 7.57306C12 7.57306 10.8535 6.34577 9.25685 7.17833C7.32296 8.18673 7.18408 12.1357 12 13.8887C16.816 12.1357 16.677 8.18673 14.7431 7.17834Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LocationFavourite02Icon;
